import { render, staticRenderFns } from "./approved-tab.vue?vue&type=template&id=2068e197"
import script from "./approved-tab.vue?vue&type=script&lang=js"
export * from "./approved-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports